import styled from "styled-components";

/* Cabecera y botones quedan fijos; lo que hace scroll son las preguntas */
export const Modal = styled.form`
  background: #fff;
  border-radius: 14px;
  width: 100%;
  max-width: 768px;
  max-height: 90vh;
  padding: 24px 32px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  box-shadow: 0 6px 24px rgba(0, 0, 0, 0.18);
  box-sizing: border-box;

  @media (max-width: 600px) { padding: 20px 16px; }
`;

export const Header = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
`;

export const CloseButton = styled.button`
  padding: 0;
  border: none;
  background: none;
  color: #6f7a83;
  font-size: 1.6rem;
  line-height: 1;
  cursor: pointer;

  &:hover { color: #1b2b3a; }
`;

export const Questions = styled.div`
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding-right: 8px;
`;

export const Question = styled.fieldset`
  border: 0;
  margin: 0;
  padding: 0;
  min-width: 0;
`;

export const QuestionLabel = styled.legend`
  padding: 0;
  margin-bottom: 8px;
  font-size: 0.82rem;
  font-weight: 700;
  color: #1b2b3a;
`;

export const ScaleOptions = styled.div`
  display: grid;
  grid-template-columns: repeat(${({ $columns }) => $columns}, minmax(0, 1fr));
  gap: 8px;
`;

export const ScaleOption = styled.label`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 0.78rem;
  line-height: 1.25;
  text-align: center;
  color: #333;
  cursor: pointer;

  @media (max-width: 600px) { font-size: 0.68rem; }
`;

export const ScaleValue = styled.span`
  margin-top: 8px;
`;

export const ActionRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding-top: 8px;
`;

export const ConfirmModal = styled.div`
  background: #fff;
  border-radius: 14px;
  width: 100%;
  max-width: 512px;
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 14px;
  box-shadow: 0 6px 24px rgba(0, 0, 0, 0.18);
  box-sizing: border-box;
`;

export const ConfirmTitle = styled.h2`
  margin: 0;
  font-size: 1.05rem;
  font-weight: 700;
  color: #1b2b3a;
`;

export const ConfirmBody = styled.p`
  margin: 0 0 18px;
  font-size: 0.85rem;
  line-height: 1.45;
  color: #333;
`;

export const ReviewButton = styled.button`
  padding: 8px 18px;
  border-radius: 7px;
  border: 1.5px solid #1b5f6e;
  background: #fff;
  color: #1b5f6e;
  font-size: 0.85rem;
  cursor: pointer;

  &:hover { background: #eef6f7; }
`;

export const ConfirmButton = styled.button`
  padding: 8px 18px;
  border-radius: 7px;
  border: none;
  background: #9E1B32;
  color: #fff;
  font-size: 0.85rem;
  font-weight: 600;
  cursor: pointer;

  &:hover { background: #851527; }
  &:disabled { background: #d9d9d9; cursor: not-allowed; }
`;
